import { Badge } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div<{ background?: string; width?: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${p => p.width || '36px'};
  height: ${p => p.width || '36px'};
  border-radius: 50%;
  background-color: ${p => p.background || ''};
  flex-shrink: 0;
`;

export const CBadge = styled(Badge)`
  position: absolute !important;
  top: 0px;
  /* right: -12px; */
  .ant-badge-dot {
    width: 12px;
    height: 12px;
  }
`;
